import '/@admin:css/style.css'
import '@github/relative-time-element'

import { createInertiaApp, router } from '@inertiajs/vue3'
import type { DefineComponent } from 'vue'
import { createApp, h } from 'vue'
import { toast } from 'vue-sonner'

import { registerPlugins } from './shared/plugins'
import { ucfirst } from './shared/utils'

const appName = import.meta.env.VITE_APP_TITLE

createInertiaApp({
  title: (title) => {
    return ucfirst(`${title} - ${appName}`)
  },
  resolve: (name) => {
    const pages = import.meta.glob('./pages/**/*.vue', { eager: false })

    return pages[`./pages/${name}.vue`]() as Promise<DefineComponent>
  },
  setup: ({ el, App, props, plugin }) => {
    const app = createApp({
      name: 'AppMain',
      render: () => h(App, props),
    })

    registerPlugins(app)

    app.use(plugin).mount(el)
  },
})

router.on('invalid', (event) => {
  if (event.detail.response.status === 419) {
    toast.error('Your session has expired. Reloading...')

    event.preventDefault()

    setTimeout(() => {
      router.reload()
    }, 2000)
  }
})
